/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

export const LOCAL_HOSTS: readonly string[] = [
    'localhost',
    'local.maestro.amazon.dev',
    'bs-local.com',
    // Caddy fronts the dev server here (start:full); traffic still terminates
    // at the local Vite proxy, so treat it as local, not cross-origin.
    'local.music.amazon.com',
] as const

/**
 * Hosts that front a same-origin `/proxy/*` server, so the app must route its
 * CORS-blocked upstreams (music/api/prs/agents/feedback/purchase) through `/proxy/*`
 * rather than hitting the live host. This is every local dev host (the Vite
 * proxy) PLUS the self-hosted web deployment (`@amzn/amp-proxy-service` at
 * `amp.music.amazon.dev/proxy`). Kept distinct from `LOCAL_HOSTS`, which gates
 * dev-only concerns like default debug logging — the self-host is production,
 * so it belongs here but NOT there.
 */
export const PROXY_HOSTS: readonly string[] = [...LOCAL_HOSTS, 'amp.music.amazon.dev'] as const

/** True when `hostname` (defaults to the current page's) is a local dev host. */
export function isLocalHost(
    hostname: string = typeof location !== 'undefined' ? location.hostname : ''
): boolean {
    return LOCAL_HOSTS.includes(hostname)
}
